import { IRoutes, LRoute } from "./types";

type IDMap = { [id: string]: LRoute };
type DirMap = {
	map: IDMap;
	dir: number;
};
type RIDMap = { [id: string]: DirMap };

const codes = [0x01, 0x02, 0x04, 0x08, 0x00, 0x10, 0x20, 0x40, 0x80];

export default class Routes implements IRoutes {
	private _map: RIDMap;
	constructor() {
		this._map = {};
	}

	public getRoute(a: string, b: string): LRoute {
		const t = this._map[a];
		if (!t) return null;

		return t.map[b] || null;
	}

	public addRoute(a: string, b: string, dx: number, dy: number) {
		this.addPath(a, b, dx, dy);
		this.addPath(b, a, -dx, -dy);
	}

	public hasRoute(a: string, dx: number, dy: number): boolean {
		const t = this._map[a];
		if (!t) return false;

		return (t.dir & this._code(dx, dy)) > 0;
	}

	public isAligned(a: string): boolean {
		return !!this._map[a];
	}

	public isAxisAligned(a: string, dx: number, dy: number): boolean {
		const t = this._map[a];
		if (!t) return null;

		for (const key in t.map) {
			const link = t.map[key];
			if ((dx && link.dy) || (dy && link.dx)) return false;
		}

		return true;
	}

	public addPath(a: string, b: string, dx: number, dy: number, points?: number[]) {
		let t = this._map[a];
		if (!t) {
			t = this._map[a] = { map: {}, dir: 0 };
		}

		t.map[b] = { dx, dy, points };
		t.dir = t.dir | this._code(dx, dy);
	}

	private _code(dx: number, dy: number): number {
		return codes[Math.sign(dx) + 1 + (Math.sign(dy) + 1) * 3];
	}
}
